/**
 * Marketplace Component Constants
 * Shared constants for listing cards and marketplace components
 */

// Category-specific placeholder images
export const CATEGORY_IMAGES = {
  'real-estate': 'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?w=400&h=300&fit=crop',
  'vehicles': 'https://images.unsplash.com/photo-1494976388531-d1058494cdd8?w=400&h=300&fit=crop',
  'electronics': 'https://images.unsplash.com/photo-1498049794561-7780e7231661?w=400&h=300&fit=crop',
  'fashion': 'https://images.unsplash.com/photo-1445205170230-053b83016050?w=400&h=300&fit=crop',
  'furniture': 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=400&h=300&fit=crop',
  'services': 'https://images.unsplash.com/photo-1521791136064-7986c2920216?w=400&h=300&fit=crop',
  'jobs': 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=300&fit=crop',
  'other': 'https://images.unsplash.com/photo-1472851294608-062f824d29cc?w=400&h=300&fit=crop',
};

// Category icons mapping
import { Home, Car, Smartphone, Shirt, Sofa, Wrench, Briefcase, Package } from 'lucide-react';

export const CATEGORY_ICONS = {
  'real-estate': Home,
  'vehicles': Car,
  'electronics': Smartphone,
  'fashion': Shirt,
  'furniture': Sofa,
  'services': Wrench,
  'jobs': Briefcase,
  'other': Package,
};

// Default image for unknown categories
export const DEFAULT_IMAGE = CATEGORY_IMAGES['other'];
